import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import {
  BrowserRouter,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './redux/store'
import { Toaster } from 'react-hot-toast'
import * as Sentry from '@sentry/react'
import ErrorPage from './component/ErrorBoundary/ErrorPage'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: `${import.meta.env.VITE_SENTRY_DSN}`,
    environment: `${import.meta.env.VITE_ENV}`,
    release: import.meta.env.SENTRY_RELEASE, // define in vite.config.ts
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    beforeSend(event) {
      if (event.tags == null) {
        event.tags = {}
      }
      // Add service name to tags
      event.tags['service_name'] = 'lotto-ui-v2'
      return event
    },

    ignoreErrors: [
      // Error from Chrome. Ignore until issue solved. Ref: https://issuetracker.google.com/issues/396043331
      "Can't find variable: gmo",
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

// Sentry.captureException("TESTING SENTRY");

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <ErrorPage
          error={error}
          componentStack={componentStack}
          resetError={resetError}
        />
      )}
    >
      <BrowserRouter>
        <Provider store={store}>
          <App />
          <Toaster position="top-right" />
        </Provider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
